__turbopack_context__.v({
  "pinned": "_-module__oPnnRW__pinned",
  "tab": "_-module__oPnnRW__tab",
  "tab-container": "_-module__oPnnRW__tab-container",
  "tab-container-scroller": "_-module__oPnnRW__tab-container-scroller",
});
